import { makeAutoObservable, autorun } from 'mobx'

class LoadingAnimationStore {
  constructor() {
    makeAutoObservable(this)
    autorun(() => {
      this.isVisible = this.loadingQueue.length !== 0
    })
  }

  /** Loading queue */
  loadingQueue = []

  /** Loading spinner state */
  isVisible = false
  showSpinner = state => {
    state ? this.loadingQueue.push(1) : this.loadingQueue.pop()
  }

  /** Table loading **/
  tableLoading = false

  setTableLoading = state => {
    this.tableLoading = state
  }

  /** Clear data */
  clearStore = () => {
    this.tableLoading = false
    this.isVisible = false
    this.loadingQueue.length = 0
  }

  showSpinInline = false

  setShowSpinInline = state => {
    this.showSpinInline = state
  }
}

export default new LoadingAnimationStore()
